import React, { useState } from "react";
import { useAdminAuth } from "./AdminAuthContext";
import { formatApiErrorDetail } from "./adminApi";
import Logo from "../components/Logo";
import PasswordInput from "../components/PasswordInput";

export default function AdminLogin() {
    const { login } = useAdminAuth();
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [error, setError] = useState("");
    const [submitting, setSubmitting] = useState(false);

    const onSubmit = async (e) => {
        e.preventDefault();
        setError("");
        setSubmitting(true);
        try {
            await login(email, password);
            // Redirect happens via parent auth state change
        } catch (err) {
            setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
        } finally {
            setSubmitting(false);
        }
    };

    return (
        <div className="min-h-screen bg-cream flex items-center justify-center px-6" data-testid="admin-login">
            <div className="w-full max-w-sm">
                <div className="flex flex-col items-center mb-10">
                    <Logo size={120} />
                    <div className="mt-4 text-[10px] tracking-[0.32em] uppercase text-burgundy/80">
                        Operator console
                    </div>
                </div>

                <div className="border border-burgundy/15 bg-cream-soft p-7">
                    <h1 className="font-display text-3xl text-burgundy">
                        <span className="italic">Sign in</span>
                    </h1>
                    <p className="mt-1 text-sm text-ink-muted">Admins only.</p>

                    <form onSubmit={onSubmit} className="mt-6 space-y-4">
                        <div>
                            <label className="text-[10px] tracking-[0.28em] uppercase text-ink-muted">
                                Email
                            </label>
                            <input
                                data-testid="admin-email-input"
                                type="email"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                required
                                autoFocus
                                className="mt-1 w-full bg-transparent border-b border-burgundy/30 focus:border-burgundy py-2 font-display text-xl text-burgundy focus:outline-none"
                            />
                        </div>
                        <div>
                            <label className="text-[10px] tracking-[0.28em] uppercase text-ink-muted">
                                Password
                            </label>
                            <PasswordInput
                                testId="admin-password-input"
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                required
                                className="mt-1 w-full bg-transparent border-b border-burgundy/30 focus:border-burgundy py-2 font-display text-xl text-burgundy focus:outline-none"
                            />
                        </div>

                        {error && (
                            <div data-testid="admin-login-error" className="text-sm text-burgundy bg-rose/20 border border-burgundy/20 px-3 py-2">
                                {error}
                            </div>
                        )}

                        <button
                            data-testid="admin-login-submit"
                            type="submit"
                            disabled={submitting}
                            className="w-full bg-burgundy text-cream uppercase text-xs tracking-[0.22em] py-3.5 hover:bg-burgundy-deep transition-colors disabled:opacity-60"
                        >
                            {submitting ? "Signing in…" : "Sign in"}
                        </button>
                    </form>
                </div>

                <a
                    href="/"
                    className="block text-center mt-6 text-[11px] tracking-[0.28em] uppercase text-ink-muted underline-offset-4 hover:underline"
                >
                    ← Back to app
                </a>
            </div>
        </div>
    );
}
